<template>
  <div>
    <v-app-bar color="primary" flat>
      <v-spacer></v-spacer>
      <img
        :src="`${publicPath}img/logo-white-small.png`"
        style="max-height: 26px; height: 100%"
      />
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container>
      <div class="mt-5">
        กรุณากรอกอีเมล เพื่อรับหนังสือรับรองการชำระเบี้ยประกันภัย
      </div>
      <div class="mt-6">*อีเมล</div>
      <div class="text-center">
        <!-- <h3>GENERALI LINE CONNECT</h3> -->
        <ValidationObserver v-slot="{ invalid }">
          <ValidationProvider
            v-slot="{ errors, valid }"
            :rules="{
              required: true,
              email: true,
            }"
            name="อีเมล"
          >
            <v-text-field
              ref="email"
              v-model="email"
              :error-messages="errors"
              :hide-details="errors.length == 0"
              :success="valid"
              label
              outlined
              prepend-inner-icon="mdi-email-outline"
            ></v-text-field>
          </ValidationProvider>

          <v-btn
            :disabled="invalid || loading"
            :loading="loading"
            class="mt-6"
            color="primary"
            depressed
            tile
            @click="send"
            >ส่ง
          </v-btn>
        </ValidationObserver>
      </div>
    </v-container>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-text class="pt-7 pb-3"
          >{{
            `ทางเราได้ส่งเอกสารหนังสือรับรองการชำระเบี้ยไปยังอีเมล ${email} เรียบร้อยแล้ว`
          }}
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      loading: false,
      email: "",
      dialog: false,
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mounted() {
    // let vm = this;
    // // if (typeof vm.$liff !== "undefined") {
    // vm.$liff.init(
    //   /* eslint-disable no-unused-vars */
    //   data => {
    //   }
    // );
    // }
  },
  methods: {
    send() {
      let vm = this;
      vm.loading = true;

      const apiUrl = this.$store.state.serverUrl;
      const apiToken = this.$store.state.apiToken;
      const apiKey = this.$store.state.serverApiKey;

      axios.defaults.headers.common = {
        AUTHORIZATION: `BEARER ${apiToken}`,
        "x-api-key": apiKey,
      };
      axios
        .post(`${apiUrl}api/generali/sendcertificate`, {
          idcard: vm.$route.query.idcard,
          email: vm.email,
        })
        .then(() => {
          vm.loading = false;
          vm.dialog = true;
          // vm.$swal({
          //   icon: "success",
          //   type: "success",
          //   title: "เสร็จสิ้น"
          // }).then(() => {
          //   if (typeof vm.$liff !== "undefined") {
          //     vm.$liff.closeWindow();
          //   } else {
          //     window.close();
          //   }
          // });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
